/**
 * Filter a Map instance using a function.
 *
 * @param {Map} map - Map to filter
 * @param {function(object, object):boolean} fn - Function invoked with all pairs
 *   of key/value from `map`. When the function returns true, then the pair is inserted
 *   in the result map
 */
export function filter({ map, fn }) {
	const result = new Map();
	for (const [key, value] of map) {
		if (fn(key, value)) {
			result.set(key, value);
		}
	}

	return result;
}

/**
 * Filter a Map instance by keys.
 *
 * @param {Map} map - Map to filter
 * @param {object[]} keys - List of keys to select
 */
export function filterWithKeys({ map, keys }) {
	return filter({
		map,
		fn: (key) => keys.includes(key),
	});
}
